import { useState } from 'react'
import { FormHelperText } from '@maas-components/core'
import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import { getErrorMessage, validateField } from 'core/common/utils/validation'
import TextField from 'core/components/TextField'
import ModalTitle from '../ModalTitle'
import TextHelper from '../TextHelper'

function ProductName({
  hasSuggestion,
  showWordLimit,
  className,
  textLimit,
  placeholder,
  onChange,
}) {
  const [openSuggestionModal, setOpenSuggestionModal] = useState(false)

  const { values, handleChange, handleBlur, errors, touched, submitCount } = useFormikContext()

  const renderFieldSuggestion = () => {
    if (!hasSuggestion) return null

    return (
      <>
        <TextHelper
          setMarginTop={getErrorMessage('name', errors, touched)}
          handleCLick={() => setOpenSuggestionModal(true)}
        >
          {i18n.t('product.scopes.description.labelTitleStore')}
        </TextHelper>
        <ModalTitle open={openSuggestionModal} handleClose={() => setOpenSuggestionModal(false)} />
      </>
    )
  }

  const renderWordCounter = () => {
    if (!showWordLimit) return null

    return (
      <FormHelperText className="align-self-end">
        {`${values?.name?.length} ${
          textLimit
            ? i18n.t('product.scopes.name.netsNameLimit')
            : i18n.t('product.scopes.name.nameLimit')
        }`}
      </FormHelperText>
    )
  }

  return (
    <div className={`d-flex flex-column w-100 ${className}`}>
      <TextField
        fullWidth
        error={validateField('name', errors, touched, submitCount > 0)}
        helperText={getErrorMessage('name', errors, touched)}
        label={!placeholder ? i18n.t('product.scopes.description.labelName') : null}
        name="name"
        onBlur={handleBlur}
        onChange={e => {
          handleChange(e)
          onChange()
        }}
        sanitize
        value={values?.name}
        variant="outlined"
        inputProps={{ maxLength: textLimit || 150, minLength: 1 }}
        required
        placeholder={placeholder}
      />
      {renderFieldSuggestion()}
      {renderWordCounter()}
    </div>
  )
}

export default ProductName
